import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Main from "./Main";

const ViewCED = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>Currency Exchange Details - View</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
                <Main/>
            </div>
        </div>
  );
};

export default ViewCED;
